var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField } from '@one-thd/sui-atomic-components';
import { getTextFieldStatus } from '../../../utils/form';
import { ZIPCODE_LENGTH } from '../../../constants/general';
import { useZipCode } from '../../../hooks/use-zipcode';
import { CityStateSelect } from '../city-state-select/city-state-select';
export var ZipCodeCitySelectFields = function (_a) {
    var spacingY = _a.spacingY;
    var _b = useFormContext(), control = _b.control, formErrors = _b.formState.errors, getValues = _b.getValues, setValue = _b.setValue, trigger = _b.trigger;
    var zipCodeValue = getValues('zipCode');
    var cityStateValue = getValues('cityState');
    var _c = useZipCode(zipCodeValue, cityStateValue), isZipCodePending = _c.isZipCodePending, zipCodeApiError = _c.zipCodeApiError, zipCodeNotFoundError = _c.zipCodeNotFoundError, cities = _c.cities, cityState = _c.cityState, loadCities = _c.loadCities;
    useEffect(function () {
        setValue('cityState', cityState);
        setValue('isZipCodePending', isZipCodePending);
        setValue('isZipCodeApiError', zipCodeApiError);
        setValue('isZipCodeNotFoundError', zipCodeNotFoundError);
        if (zipCodeNotFoundError || zipCodeApiError) {
            trigger('zipCode');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cityState, isZipCodePending, zipCodeApiError, zipCodeNotFoundError]);
    var handleZipCodeChange = function (event) {
        var newZipCode = event.currentTarget.value;
        loadCities(newZipCode);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-grid sui-gap-y-".concat((spacingY === null || spacingY === void 0 ? void 0 : spacingY.toString()) || 6) },
            React.createElement(Controller, { name: "zipCode", control: control, render: function (_a) {
                    var _b;
                    var _c = _a.field, onChange = _c.onChange, ref = _c.ref, restField = __rest(_c, ["onChange", "ref"]);
                    return (React.createElement(TextField, { label: "ZIP Code*", status: getTextFieldStatus(formErrors.zipCode), statusMessage: (_b = formErrors.zipCode) === null || _b === void 0 ? void 0 : _b.message, inputProps: __assign({ maxLength: ZIPCODE_LENGTH, onChange: function (event) {
                                handleZipCodeChange(event);
                                onChange(event);
                            } }, restField) }));
                } }),
            React.createElement(Controller, { name: "cityState", control: control, render: function (_a) {
                    var field = _a.field;
                    var ref = field.ref, rest = __rest(field, ["ref"]);
                    return (React.createElement(CityStateSelect, __assign({ "data-testid": "cityState", cities: cities }, rest)));
                } }))));
};
